import { parseTransferOrderQuantity } from './item-quantity.js';
export function emptyTransferOrderCreateForm() {
    return {
        brandId: '',
        fromLocationGroupId: '',
        shipToLocationGroupId: '',
        carrierId: '',
        carrierServiceId: '',
        dateScheduled: '',
        splitOnShortPick: true,
        ownerIsFrom: true,
        note: '',
        lines: [],
    };
}
function toDateIso(value) {
    return new Date(value.trim()).toISOString();
}
function mapLine(line) {
    if (!line.partId) {
        return undefined;
    }
    const qty = parseTransferOrderQuantity(line.qty);
    if (qty === undefined) {
        return undefined;
    }
    return {
        partId: line.partId,
        qty,
    };
}
export function toCreateTransferOrderInput(values) {
    const note = values.note.trim();
    const carrierServiceId = values.carrierServiceId.trim();
    const items = values.lines
        .map(mapLine)
        .filter((item) => item !== undefined);
    return {
        brandId: values.brandId,
        fromLocationGroupId: values.fromLocationGroupId,
        shipToLocationGroupId: values.shipToLocationGroupId,
        carrierId: values.carrierId,
        ...(carrierServiceId && { carrierServiceId }),
        ...(values.dateScheduled.trim() && { dateScheduled: toDateIso(values.dateScheduled) }),
        splitOnShortPick: values.splitOnShortPick,
        ownerIsFrom: values.ownerIsFrom,
        note: note || undefined,
        items,
    };
}
//# sourceMappingURL=create-mapper.js.map